import React from 'react';
import { ButtonLink, Markdown } from '@glowforge/ui-common/components';
import { Image } from '@glowforge/ui-common/components/contentful-views';
import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/ui-common/models';

const ThankYou = ({
  getString,
  markdownStrings,
  onClose,
  strings,
  thankYouImage,
}) => (
  <div className='thank-you-step' id='swag'>
    <div className='thank-you-bg' />
    <Image media={thankYouImage} width={160} className='thank-you-image' />
    <div className='thank-you-body'>
      <Markdown source={getString(markdownStrings, 'thank-you-body')} />
    </div>
    <div className='modal-actions'>
      <ButtonLink
        className='thank-you-redirect'
        onClick={onClose || null}
        text={getString(strings, 'thank-you-redirect-label')}
        url={getString(strings, 'thank-you-redirect-url')}
        rel='noopener'
        target='_blank'
      />
    </div>
    {onClose ? (
      <p className='fine-print'>
        <ButtonLink
          className='thank-you-close-link'
          type='text'
          text={getString(strings, 'thank-you-close-link')}
          onClick={onClose}
        />
      </p>
    ) : null}
  </div>
);

ThankYou.propTypes = widgetPropType;
ThankYou.defaultProps = widgetDefaultProps;

export default ThankYou;
